import { useEffect, useState } from "react";
import { IuseRealWeightProps } from "../interfaces";

export const useRealWeight = ({
  currentRealWeight = 0,
  newRealWeight = 0,
  previousRealWeight = 0,
}: IuseRealWeightProps) => {
  const [realWeight, setRealWeight] = useState<number>(0);

  const totalRealWeight: number =
    +currentRealWeight.toFixed(2) -
    +previousRealWeight.toFixed(2) +
    +newRealWeight.toFixed(2);

  useEffect(() => {
    setRealWeight(totalRealWeight);
  }, [totalRealWeight]);
  return {
    currentRealWeight: +currentRealWeight.toFixed(2),
    totalRealWeight: +realWeight.toFixed(2),
  };
};
